const API = {
  getPerformanceChartData: (isin) => fetch(`${process.env.REACT_APP_DATASPAN_API_URL}/funddetails/calendar_year_performance?isin=${isin}`)
    .then((response) => response.json())
    .then(data => data),
};

export default API;
